module.exports = __webpack_public_path__ + "img/slider-products-fyroro.629dfa2d.webp";